import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface RadioButtonItem {
  id: number;
  value: string;
}

@Component({
  selector: 'pds-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioButtonComponent)
    }
  ]
})
export class RadioButtonComponent implements OnInit, ControlValueAccessor {

  @Input() items: Array<RadioButtonItem>;
  @Input() value: any;
  @Input() formControlName: string;
  public disabled: boolean;
  public onChange = (_: any) => {};
  public onTouched = () => {};

  constructor() { }

  ngOnInit(): void {
  }

  onSelected(value: any){
    this.value = value;
    this.onTouched();
    this.onChange(this.value);
  }

  writeValue(value: any) {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

}
